<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Button from 'next/button/Button.vue';
import SelectMenu from 'next/selectmenu/SelectMenu.vue';

const props = defineProps({
  activeSort: {
    type: String,
    default: 'created_at',
  },
  activeOrdering: {
    type: String,
    default: 'desc',
  },
});

const emit = defineEmits(['update:sort']);

const { t } = useI18n();

const isMenuOpen = ref(false);

const sortMenus = computed(() => [
  {
    label: t('WGPT_SOCIAL_MEDIA_POSTS.SORT.OPTIONS.CREATED_AT'),
    value: 'created_at',
  },
]);

const orderingMenus = computed(() => [
  {
    label: t('WGPT_SOCIAL_MEDIA_POSTS.SORT.ORDER.OPTIONS.ASCENDING'),
    value: 'asc',
  },
  {
    label: t('WGPT_SOCIAL_MEDIA_POSTS.SORT.ORDER.OPTIONS.DESCENDING'),
    value: 'desc',
  },
]);

const activeSortLabel = computed(() => {
  const selectedMenu = sortMenus.value.find(
    menu => menu.value === props.activeSort
  );
  return selectedMenu?.label || t('WGPT_SOCIAL_MEDIA_POSTS.SORT.LABEL');
});

const activeOrderingLabel = computed(() => {
  const selectedMenu = orderingMenus.value.find(
    menu => menu.value === props.activeOrdering
  );
  return selectedMenu?.label || t('WGPT_SOCIAL_MEDIA_POSTS.SORT.ORDER.LABEL');
});

const handleSortChange = value => {
  emit('update:sort', { sort: value, order: props.activeOrdering });
};

const handleOrderChange = value => {
  isMenuOpen.value = false;
  emit('update:sort', { sort: props.activeSort, order: value });
};
</script>

<template>
  <div class="relative">
    <Button
      icon="i-lucide-arrow-down-up"
      color="slate"
      size="sm"
      variant="ghost"
      :class="isMenuOpen ? 'bg-n-alpha-2' : ''"
      @click="isMenuOpen = !isMenuOpen"
    />
    <div
      v-if="isMenuOpen"
      v-on-clickaway="() => (isMenuOpen = false)"
      class="absolute top-full mt-1 ltr:-right-32 rtl:-left-32 sm:ltr:right-0 sm:rtl:left-0 flex flex-col gap-4 bg-n-alpha-3 backdrop-blur-[100px] border border-n-weak w-72 rounded-xl p-4 z-50"
    >
      <div class="flex items-center justify-between gap-2">
        <span class="text-sm text-n-slate-12">
          {{ t('WGPT_SOCIAL_MEDIA_POSTS.SORT.LABEL') }}
        </span>
        <SelectMenu
          :model-value="activeSort"
          :options="sortMenus"
          :label="activeSortLabel"
          @update:model-value="handleSortChange"
        />
      </div>
      <div class="flex items-center justify-between gap-2">
        <span class="text-sm text-n-slate-12">
          {{ t('WGPT_SOCIAL_MEDIA_POSTS.SORT.ORDER.LABEL') }}
        </span>
        <SelectMenu
          :model-value="activeOrdering"
          :options="orderingMenus"
          :label="activeOrderingLabel"
          @update:model-value="handleOrderChange"
        />
      </div>
    </div>
  </div>
</template>
